import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface CheckNotActivePictoProps extends pictoProps {
}

export interface CheckNotActivePictoState extends pictoState {
}

export class CheckNotActivePicto extends Picto<CheckNotActivePictoProps,CheckNotActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.checkNotActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(CheckNotActivePicto);
